import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort-asc",
  "use": "sort-asc-usage",
  "viewBox": "0 0 16 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 28\" id=\"sort-asc\"><path fill=\"currentColor\" d=\"M16 11c0 .547-.453 1-1 1H1c-.547 0-1-.453-1-1a.99.99 0 01.297-.703l7-7C7.484 3.11 7.735 3 8 3s.516.109.703.297l7 7A.996.996 0 0116 11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol